import { PlusIcon } from "components/common/Icons/PlusIcon";
import { ReactNode, RefObject } from "react";

interface ColorPickerButtonContainerProps {
    isActive: boolean;
    onClick: () => void;
    ref?: RefObject<HTMLButtonElement>;
    absoluteElement?: ReactNode;
}

export const ColorPickerButtonContainer = ({
    isActive,
    onClick,
    ref,
    absoluteElement,
}: ColorPickerButtonContainerProps) => {
    return (
        <button
            className={`relative w-12 h-12 flex-shrink-0 rounded-full p-0.5 border-2 ${
                isActive ? "border-irBlue-200 dark:border-darkPrimary-100" : "border-white dark:border-darkSurface-400"
            }`}
            onClick={onClick}
            ref={ref}
        >
            <div
                className={"w-full h-full rounded-full p-1.5"}
                style={{
                    background:
                        "linear-gradient(139.27deg, #1C40B7 -0.22%, #F708BD 23.63%, #0B90F7 47.41%, #FD1D48 70.23%, #F7610F 87.07%, #F9BF0F 102.66%)",
                }}
            >
                <div className="h-full w-full bg-white rounded-full flex items-center justify-center">
                    <PlusIcon className="fill-black dark:fill-black" />
                </div>
            </div>
            {absoluteElement}
        </button>
    );
};
